import { Button, LoginGoogleIcon } from '@calizahq/react-components-v2'
import { useState } from 'react'

import { GoogleAuthAPI } from '@/api'
import { FilterActions, useFiltersContext, useUserContext } from '@/context'
import { useAPIMutation } from '@/hooks'
import { UserRolesIdMapping } from '@/util'

import { ErrorMessages, SignInErrorMessages } from './SignIn.data'
import { useGoogleSignin } from './useGoogleSignin'

const GOOGLE_APP_ID = process.env.GOOGLE_APP_ID

export interface SignInProps {
  className?: string
}

export function SignIn() {
  const [, FilterDispatch] = useFiltersContext()
  const [error, setError] = useState('')
  const { updateUser, setLoading, isLoading } = useUserContext()
  const { signInGoogle } = useGoogleSignin({
    onSuccess: handleSuccessGoogle,
    // eslint-disable-next-line no-console
    onError: (err) => console.warn(err),
  })

  const { mutateAsync: loginGoogleMutate } = useAPIMutation<GoogleAuthAPI.POST.Body, GoogleAuthAPI.POST.Response>(
    GoogleAuthAPI.post(),
    {
      onError: handleError,
    },
  )

  async function handleSuccessGoogle(res: { credential: string }) {
    try {
      const { data } = await loginGoogleMutate({ google_token: res.credential })

      const userData = data?.user
      document.cookie = `token=${data.token};path=/`
      updateUser({
        agent: userData?.agent,
        auth_token: data.token,
        email: userData?.email,
        fullName: userData?.full_name,
        id: userData.id,
        isAgm: userData.is_agm,
        isBilling: userData.is_billing,
        isHubManager: userData.is_hub_manager,
        isSuperAdmin: userData.is_super_admin,
        isXteam: userData.is_xteam,
        marketSegmentIds: userData?.market_segment_ids,
        role: userData?.role ? UserRolesIdMapping[userData?.role] : 0,
        homeBlockPermitted: userData.home_block_permitted,
      })
      if (userData?.market_segment_ids && userData?.market_segment_ids.length) {
        FilterDispatch(
          FilterActions.setMarketSegments({
            ids: [...userData?.market_segment_ids],
            fieldOperationsHubs: [],
            fieldOperationsRegions: [],
            marketSegmentTypes: [],
          }),
        )
      }
      setError('')
    } catch (error) {
      handleError({ error })
    }
  }

  function handleError({ response }: any) {
    if (response == ErrorMessages.TEMP_ERROR) {
      setError(SignInErrorMessages.TEMP_LOGIN)
    } else {
      const errorMessage = response?.data.error || SignInErrorMessages.DEFAULT
      setError(errorMessage)
    }
  }

  return (
    <div>
      {!!GOOGLE_APP_ID && (
        <Button
          className="flex w-full bg-action-secondary font-bold"
          isLoading={isLoading}
          onClick={() => {
            setLoading(true)
            signInGoogle()
          }}
          renderLeftIcon={LoginGoogleIcon}
          variant="secondary"
        >
          Sign in with Google
        </Button>
      )}
      {error && <p className="text-p-sm text-semantic-error">{error}</p>}
    </div>
  )
}
